<template>
  <div
      class="px-3 pb-3 d-flex"
      :class="message.info.user.userId===$store.state.user?.id || message.info.user.userType==='admin' || message.info.user.userType==='spec' ? 'justify-end' : 'justify-start'"
  >
    <v-sheet
        class="d-inline-block text-left overflow-hidden" style="border:solid 1px #DDD !important;max-width:50%"
        rounded
        :color="message.info.user.userId===$store.state.user?.id ? 'light-green lighten-5' : 'white'"
    >
      <div class="px-2 py-1" :class="messageClass">
        <div v-if="message.info.user.userId===null" class="caption">
          {{message.info.user.fullName}}
        </div>
        <a v-else class="caption" :href="'/panel/user/'+message.info.user.userType+'/'+message.info.user.userId+'/'" target="_blank">
          {{message.info.user.fullName}}
        </a>
        <div v-if="!$tools.isEmpty(message.text)" v-html="$tools.nl2br(message.text)" class="body-2 mt-1 mb-2"></div>
        <div v-if="!$tools.isEmpty(message.mediaPath)" class="body-2 mt-1 mb-2">
          <v-sheet
              v-if="$tools.getFileTypeByPath(message.mediaPath).includes('image')"
              @click="$tools.openUrl(message.mediaPath, true)"
              width="250" height="250" class="clickable overflow-hidden" rounded color="black"
          >
            <img :src="message.mediaPath" alt="" class="full-width fill-height" style="object-fit:contain;"/>
          </v-sheet>
          <v-sheet
              v-else-if="$tools.getFileTypeByPath(message.mediaPath).includes('audio')"
              width="500" color="transparent"
          >
            <audio :src="message.mediaPath" controls class="mt-2">
              Прослушивание не поддерживается вашим браузером.
              <a :href="message.mediaPath" target="_blank">Скачать</a>.
            </audio>
          </v-sheet>
          <v-sheet
              v-else-if="$tools.getFileTypeByPath(message.mediaPath).includes('video')"
              width="250" height="250" class="clickable overflow-hidden" rounded color="black"
          >
            <video :src="message.mediaPath" controls class="full-width fill-height"></video>
          </v-sheet>
          <div v-else-if="$tools.getFileTypeByPath(message.mediaPath).includes('unknown')">
            <v-btn small depressed @click="$tools.openUrl(message.mediaPath, true)">
              <v-icon small class="mr-2">mdi-file</v-icon>Файл "{{message.mediaPath.split('.').pop().toLowerCase()}}"
            </v-btn>
          </div>
        </div>
        <v-row no-gutters class="caption font-weight-regular">
          <v-col cols="auto">
            <div v-if="!$tools.isEmpty(message.reaction)" class="d-inline-block">
              {{message.reaction}}
            </div>
          </v-col>
          <v-col>
          </v-col>
          <v-col cols="auto" class="pr-2">
            <tooltip-view bottom>
              <template v-slot:action>
                <v-avatar size="16" :color="message.info.messengerTypeIconBgColor">
                  <v-icon size="10" dark>{{message.info.messengerTypeIcon}}</v-icon>
                </v-avatar>
              </template>
              <template v-slot:content><div class="caption pb-2">Мессенджер: {{message.info.messengerTypeStr}}</div></template>
            </tooltip-view>
          </v-col>
          <v-col cols="auto" class="text-no-wrap pr-1">
            <tooltip-view bottom>
              <template v-slot:action>{{$tools.dateFormat(message.created)}}</template>
              <template v-slot:content><div class="caption pb-2">Отправлено: {{$tools.dateFormat(message.created, false)}}</div></template>
            </tooltip-view>
          </v-col>
          <v-col cols="auto">
            <tooltip-view v-if="message.errored" bottom>
              <template v-slot:action><v-icon color="error" size="14">mdi-close</v-icon></template>
              <template v-slot:content><div class="caption pb-2">Сообщение #{{message.id}}<br/>Ошибка при отправке сообщения: {{message.error}}</div></template>
            </tooltip-view>
            <tooltip-view v-else-if="message.readed===null" bottom>
              <template v-slot:action><v-icon size="14">mdi-check</v-icon></template>
              <template v-slot:content><div class="caption pb-2">Сообщение #{{message.id}}<br/>Не прочитано</div></template>
            </tooltip-view>
            <tooltip-view v-else bottom>
              <template v-slot:action><v-icon size="14" color="success">mdi-check-all</v-icon></template>
              <template v-slot:content><div class="caption pb-2">Сообщение #{{message.id}}<br/>Прочитано {{$tools.dateTime(message.readed, 'DD.MM.YYYY hh:mm')}}</div></template>
            </tooltip-view>
          </v-col>
        </v-row>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import TooltipView from "../../../../components/TooltipView.vue";

export default {
  components: {TooltipView},
  props: ['message'],
  data: () => ({
    messageClass:'',
  }),
  mounted() {
    if(this.message.new){
      this.messageClass = 'blinkWarning';
      setTimeout(()=>{
        this.messageClass = '';
        this.message.new = false;
      }, 2000)
    }
  },
}
</script>